<script>
import VBox from "@/components/VBox.vue";
import CloseButton from "@/components/navbar/CloseButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import FormHeader from "@/components/forms/FormHeader.vue";
import Perms from "@/server/Perms";
import VersionNode from "@/server/com/silkplm/rpc/dto/VersionNode";
import FormsAI from "@/components/forms/FormsAI";
import GalleryRenderer from "@/components/forms/renderers/GalleryRenderer.vue";
import FormModel from "@/components/forms/FormModel";

export default {
  name: "VersionChartNode",
  components: {GalleryRenderer, VBox, CloseButton, FooterNavbar, HeadersButtonGroup, FooterButton, FormHeader},
  permission: Perms.SUPERUSER,
  created() {
    console.log(this.isSelected);
    if(this.isSelected){
      this.headerStyle += " bg-success text-white ";
    }
    if(this.treeConfig.showGallery) {
      // TODO - znalezc main picture
      if(this.node.item?.gallery?.imagesList && this.node.item.gallery.imagesList.length > 0){
        this.mainPicture = this.node.item.gallery.imagesList[0];

      }
    }
  },
  methods: {
    navigate(id){
      this.treeConfig.masterComponent.navigate(id);
    },
    openEntity(id){
      this.treeConfig.masterComponent.openEntity(id);
    }
  },
  watch: {
    entityId: function(){
      this.isSelected = (this.node.item.id === this.entityId);
      if(this.isSelected){
        this.headerStyle = "card-header px-3 pt-2 pb-1 bg-success text-white ";
      } else {
        this.headerStyle = "card-header px-3 pt-2 pb-1 ";
      }
    },
  },
  props:{
    entityId: {required: true},
    node: {required:true, type: VersionNode},
    treeConfig: {required: true},
    level: {required: true}
  },
  data: function(){return {
    validatedField:  null,
    mainPicture: null,
    isSelected: (this.node.item.id === this.treeConfig.entityId),
    label: FormsAI.getEntityLabel(FormsLoader.detectFormConfig(this.node.item), this.node.item),
    hasChildren: this.node.children.length,
    headerStyle: "card-header px-3 pt-2 pb-1"
  }}
}

</script>

<template>
    <li >
<!--      <span class="tf-nc"></span>-->
      <div class="tf-nc card"  style="padding: 0">
            <div :class="headerStyle">{{ label }}</div>
              <div class="card-body px-3 py-1 text-center">
                <small class="card-title">{{ node.__versionDate }}</small>

                <img :src="mainPicture.url" v-if="mainPicture && treeConfig.showGallery"
                     alt="Image of actual product"
                     style="max-width: 100px; max-height: 80px"
                     class="align-self-center responsive-image"
                     ref="image">
                <p class="card-text"></p>

                <a href="#" class="btn btn-plm-secondary py-1 px-2 " @click="navigate(node.item.id)"><font-awesome-icon icon="bullseye-pointer"></font-awesome-icon></a>
                <a href="#" class="btn btn-plm-primary py-1 px-2" @click="openEntity(node.item.id)"><font-awesome-icon icon="arrow-right"></font-awesome-icon></a>
              </div>
        </div>
      <ul v-if="hasChildren" class="tf-org">
        <VersionChartNode v-for="child in node.children" :level="level+1" :entityId="entityId"
                          :tree-config="treeConfig" :node="child" :key="child.item.id"></VersionChartNode>
      </ul>
    </li>
</template>
